import React, { useState, useEffect, useRef } from "react";
import {
  Card,
  Typography,
  Form,
  Input,
  Select,
  Row,
  Col,
  Empty,
  Button,
  InputNumber,
  message,
  Switch,
  Divider,
  Menu,
  Tooltip,
} from "antd";
import CaSideNav from "../../../components/AdminComponents/CaSideNav";
// import SecondaryNav from "../../../components/AdminComponents/SecondaryNav2";
import {
  CourseTopLevel,
  CourseTopLevelCA,
  // TraineryLearnCaAdd,
  // TraineryLearnAdd,
} from "../../../components/AdminComponents/MenuItems";
import { remainingViewportHeight } from "../../../components/icons/ApplicationColor";
import axiosInstance from "../../../api/Axios";
import {
  BackwardOutlined,
  SaveOutlined,
  RetweetOutlined,
} from "@ant-design/icons";
import {
  FileTextOutlined,
  ReadOutlined,
  AppstoreOutlined,
  BranchesOutlined,
  TeamOutlined,
  PartitionOutlined,
} from "@ant-design/icons";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import "./courseStyles.css";
import { COURSE_ID_FIELD, COURSE_NAME_FIELD, FormInput } from "./courseForm";
import CourseAddRightBar from "./CourseEditTabs/CourseAddRightBar";
import Sidebar from "../../../components/AdminComponents/SideNav";
const { Title, Paragraph } = Typography;
const { Option } = Select;

const CourseAdd = () => {
  const location = useLocation();
  const isCAAdmin = location.pathname.includes("ca-admin");
  const userInfo = useSelector((state) => state.user);
  const history = useNavigate();
  const [formValues, setFormValues] = useState({});
  const [messageApi, contextHolder] = message.useMessage();

  const [courseType, setCourseType] = useState("Virtual");
  const [filterOptions, setFilterOptions] = useState({
    categories: [],
    producers: [],
    certificates: [],
    modes: [],
    languages: [],
    ownersList: [],
  });
  const { categories, producers, certificates, modes, languages, ownersList } =
    filterOptions;
  const [uploadedFiles, setUploadedFiles] = useState(null);
  const [tags, setTags] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedSubCategory, setSelectedSubCategory] = useState(null);
  const topCategories = categories.map((cat) => ({
    label: cat.name,
    value: cat.id,
  }));

  const subCategories =
    (selectedCategory &&
      categories
        .find((cat) => cat.id === selectedCategory)
        ?.second_categories?.map((sub) => ({
          label: sub.name,
          value: sub.id,
        }))) ||
    [];
  const updateFilterOption = (key, value) => {
    setFilterOptions((prev) => ({ ...prev, [key]: value }));
  };
  useEffect(() => {
    const LoadFilters = async () => {
      try {
        const res = await axiosInstance.get(
          `/filter/?organization=${userInfo?.data?.organization?.id}`
        );
        updateFilterOption("categories", res?.data?.categories);
      } catch (err) {
        console.log(err);
      }
    };
    const LoadFilters2 = async () => {
      try {
        const res = await axiosInstance.get(`/producerlist/`);
        updateFilterOption("producers", res?.data || []);
      } catch (err) {
        console.log(err);
      }
    };
    const LoadFilters3 = async () => {
      try {
        const res = await axiosInstance.get(`options/certificate_type/`);
        updateFilterOption("certificates", res?.data?.certificate_type || []);
      } catch (err) {
        console.log(err);
      }
    };
    const LoadFilters4 = async () => {
      try {
        const res = await axiosInstance.get(`learn/modes/`);
        updateFilterOption("modes", res?.data || []);
      } catch (err) {
        console.log(err);
      }
    };
    const LoadFilters6 = async () => {
      try {
        const res = await axiosInstance.get(
          `organizationlist/?page=1&page_size=200&status=True&application=5`
        );
        updateFilterOption("ownersList", res?.data?.results || []);
      } catch (err) {
        console.log(err);
      }
    };
    const LoadFilters5 = async () => {
      try {
        const res = await axiosInstance.get(`learn/languages/`);
        updateFilterOption("languages", res?.data || []);
      } catch (err) {
        console.log(err);
      }
    };
    LoadFilters();
    LoadFilters2();
    LoadFilters3();
    LoadFilters4();
    LoadFilters5();
    if (!isCAAdmin) {
      LoadFilters6();
    }
  }, [userInfo?.data?.organization?.id, isCAAdmin]);

  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }
  const csrfToken = getCookie("csrftoken");
  const handleSubmit = async (values) => {
    const normalizedValues = Object.fromEntries(
      Object.entries(values).filter(
        ([key, value]) => value !== null && value !== undefined
      )
    );
    const { duration, duration_type, ...rest } = normalizedValues;

    const formattedDuration =
      duration && duration_type ? `${duration} ${duration_type}` : null;

    const finalValues = {
      ...rest,
      duration: formattedDuration,
      organization: userInfo?.data?.organization?.id,
      image_url: uploadedFiles,
      tags: tags,
    };

    console.log("Form submitted with values:", finalValues);
    try {
      const res = await axiosInstance.post(
        `/courseadd/?organization=${userInfo?.data?.organization?.id}`,
        finalValues,
        {
          headers: {
            "X-CSRFToken": csrfToken,
          },
        }
      );
      CreateSuccessfull(res?.data?.data?.id);
    } catch (err) {
      CreateFailed();
    }
  };

  const CreateSuccessfull = (id) => {
    messageApi.open({
      type: "success",
      content: "Course creation success.",
      duration: 5,
    });
    setTimeout(() => {
      history(
        isCAAdmin
          ? `/ca-admin/trainery-learn/courses/edit/${id}`
          : `/trainery-learn/courses/edit/${id}`
      );
    }, 2000);
  };

  const CreateFailed = () => {
    messageApi.open({
      type: "error",
      content: "Course Creation failure",
      duration: 5,
    });
  };
  const formRef = useRef();
  const handleReset = () => {
    formRef.current.resetFields();
  };

  const [activeView, setActiveView] = useState("summary");

  const menuItems = [
    {
      key: "summary",
      label: (
        <div className="menu-vertical-item">
          <FileTextOutlined style={{ fontSize: "22px" }} />
          <div>Course Summary</div>
        </div>
      ),
      disabled: false,
    },

    {
      key: "content",
      disabled: true,
      label: (
        <div className="menu-vertical-item disabled">
          <Tooltip title="This menu will be available after saving the course">
            <span
              style={{
                pointerEvents: "auto",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <ReadOutlined style={{ fontSize: "22px" }} />
              <div>Course Content</div>
            </span>
          </Tooltip>
        </div>
      ),
    },
    isCAAdmin &&
    false && {
      key: "bundle",
      disabled: true,
      label: (
        <div className="menu-vertical-item disabled">
          <Tooltip title="This menu will be available after saving the course">
            <span
              style={{
                pointerEvents: "auto",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <AppstoreOutlined style={{ fontSize: "22px" }} />
              <div>Bundles</div>
            </span>
          </Tooltip>
        </div>
      ),
    },
    isCAAdmin && {
      key: courseType === "Virtual" ? "trainers" : "users",
      disabled: true,
      label: (
        <div className="menu-vertical-item disabled">
          <Tooltip title="This menu will be available after saving the course">
            <span
              style={{
                pointerEvents: "auto",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <TeamOutlined style={{ fontSize: "22px" }} />
              <div>{courseType === "Virtual" ? "Trainers" : "Registrations"}</div>
            </span>
          </Tooltip>
        </div>
      ),
    },
    isCAAdmin &&
    false && {
      key: "department",
      disabled: true,
      label: (
        <div className="menu-vertical-item disabled">
          <Tooltip title="This menu will be available after saving the course">
            <span
              style={{
                pointerEvents: "auto",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <BranchesOutlined style={{ fontSize: "22px" }} />
              <div>Department</div>
            </span>
          </Tooltip>
        </div>
      ),
    },
    !isCAAdmin && {
      key: "clients",
      disabled: true,
      label: (
        <div className="menu-vertical-item disabled">
          <Tooltip title="This menu will be available after saving the course">
            <span
              style={{
                pointerEvents: "auto",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <PartitionOutlined style={{ fontSize: "22px" }} />
              <div>Clients</div>
            </span>
          </Tooltip>
        </div>
      ),
    },
  ];
  const WrapperComponent = isCAAdmin ? CaSideNav : Sidebar;
  const wrapperProps = isCAAdmin ? CourseTopLevelCA : CourseTopLevel;
  return (
    <WrapperComponent props={wrapperProps}>
      {contextHolder}
      {/* <SecondaryNav
        menuItems={isCAAdmin ? TraineryLearnCaAdd : TraineryLearnAdd}
      /> */}
      <div
        style={{
          background: "#f4f4f4",
          width: "100%",
          height: remainingViewportHeight(10),
          display: "flex",
          justifyContent: "center",
          alignItems: "flex-start",
          padding: "24px",
          overflowY: "auto",
          gap: "24px",
          marginTop: "50px",
        }}
      >
        <div style={{ flexBasis: "10%", height: "100%" }}>
          <Card
            bordered
            hoverable
            style={{
              height: "100%",
              borderRadius: "12px",
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
              display: "flex",
              flexDirection: "column",
              padding: "5px",
              background: "#F9FBFC",
            }}
            className="no-padding-no-margin"
          >
            <Title
              // level={}
              style={{
                fontSize: "15.5px",
                textAlign: "center",
                width: "100%",
                // display: "block",
                fontWeight: "600",
                letterSpacing: 0.5,
                color: "#333333",
                marginTop: "28.5px",
              }}
            >
              Add Course
            </Title>

            <Divider />
            <div style={{ paddingInline: "5px" }}>
              <Menu
                className="modern-sidebar-menu"
                mode="inline"
                selectedKeys={[activeView]}
                onClick={({ key }) => setActiveView(key)}
                style={{
                  flex: 1,
                  overflowY: "auto",
                  borderRight: "none",
                  width: "100%",
                  background: "transparent",
                }}
                items={menuItems}
              />
            </div>
          </Card>
        </div>
        <div style={{ flexBasis: "70%", display: "flex" }}>
          <Card
            style={{
              width: "100%",

              marginBottom: "10px",
            }}
            hoverable
          >
            <Title level={4}>Course Creation</Title>
            <Paragraph type="secondary">
              Create and configure your new course with the details below
            </Paragraph>

            <Form
              layout="vertical"
              onFinish={handleSubmit}
              name="complex-form"
              ref={formRef}
              onValuesChange={(_, allValues) => setFormValues(allValues)}
            >
              <Row gutter={16}>
                <Col span={6}>
                  <Form.Item
                    label="Mode of Course"
                    required
                    rules={[
                      {
                        required: true,
                        message: "Course mode is required",
                      },
                    ]}
                    name="mode"
                    initialValue="Virtual"
                  >
                    <Select
                      value={courseType}
                      onChange={(value) => setCourseType(value)}
                    // options={modes}
                    >
                      {modes.map((mode) => (
                        <Option key={mode} value={mode}>
                          {mode}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <FormInput field={{ ...COURSE_NAME_FIELD, span: 12 }} />
                <FormInput field={{ ...COURSE_ID_FIELD, span: 6 }} />
              </Row>
              <Row gutter={16}>
                <Col span={9}>
                  <Form.Item
                    label="Category"
                    name="category"
                    required
                    rules={[
                      {
                        required: true,
                        message: "Category is required",
                      },
                    ]}
                  >
                    <Select
                      placeholder="Select category"
                      value={selectedCategory}
                      showSearch
                      filterOption={(input, option) =>
                        option?.label
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      onChange={(value) => {
                        setSelectedCategory(value);
                        setSelectedSubCategory(null); // Reset subcategory when parent changes
                      }}
                      options={topCategories}
                      allowClear
                    />
                  </Form.Item>
                </Col>

                <Col span={9}>
                  <Form.Item label="Sub Category" name="sub_category">
                    <Select
                      placeholder="Select subcategory"
                      value={selectedSubCategory}
                      onChange={(value) => setSelectedSubCategory(value)}
                      options={subCategories}
                      disabled={!selectedCategory}
                      notFoundContent={selectedCategory ? <Empty /> : null}
                      allowClear
                    />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    label="Language"
                    required
                    rules={[
                      {
                        required: true,
                        message: "language is required",
                      },
                    ]}
                    name="language"
                    initialValue="English"
                  >
                    <Select>
                      {languages.map((mode) => (
                        <Option key={mode} value={mode}>
                          {mode}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
              {courseType === "Virtual" && (
                <>
                  <Row gutter={16}>
                    <Col span={7}>
                      <Form.Item label="Course CPE" name="cpe">
                        <InputNumber
                          placeholder="Enter CPE credits"
                          style={{ width: "100%" }}
                          min={0}
                          parser={(value) => value.replace(/[^\d.]/g, "")}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={7}>
                      <Form.Item label="Duration" required>
                        <Input.Group compact>
                          <Form.Item
                            name="duration"
                            noStyle
                            rules={[
                              {
                                required: true,
                                message: "Please enter duration",
                              },
                            ]}
                          >
                            <Input
                              style={{ width: "60%" }}
                              placeholder="Enter number"
                            />
                          </Form.Item>

                          <Form.Item
                            name="duration_type"
                            noStyle
                            initialValue="mins"
                            rules={[
                              { required: true, message: "Please select type" },
                            ]}
                          >
                            <Select style={{ width: "40%" }}>
                              <Option value="mins">Mins</Option>
                              <Option value="hours">Hours</Option>
                            </Select>
                          </Form.Item>
                        </Input.Group>
                      </Form.Item>
                    </Col>

                    <Col span={6}>
                      <Form.Item
                        label="Type"
                        name="type"
                        initialValue="Training"
                      >
                        <Select>
                          <Option value="Training">Training</Option>
                          <Option value="Certification">Certification</Option>
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col span={4}>
                      <Form.Item
                        label="Certificate"
                        name="license"
                        required
                        rules={[
                          {
                            required: true,
                            message: "Certificate is required",
                          },
                        ]}
                      >
                        <Select placeholder="Select">
                          <Option value={true}>Yes</Option>
                          <Option value={false}>No</Option>
                        </Select>
                      </Form.Item>
                    </Col>
                  </Row>
                </>
              )}
              {courseType === "E-Learning" && (
                <>
                  <Row gutter={16}>
                    <Col span={9}>
                      <Form.Item
                        label="Course Certificate"
                        name="certificate_type"
                      >
                        <Select
                          placeholder="Select Certificate"
                          style={{ width: "100%" }}
                          allowClear
                          showSearch
                          optionFilterProp="children"
                        >
                          {certificates?.map((cert) => (
                            <Option key={cert} value={cert}>
                              {cert}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col span={9}>
                      <Form.Item label="Producer" name="producer">
                        <Select
                          placeholder="Select Producer"
                          style={{ width: "100%" }}
                          allowClear
                          showSearch
                          optionFilterProp="children"
                        >
                          {producers?.map((producer) => (
                            <Option key={producer.id} value={producer.id}>
                              {producer?.name}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col span={6}>
                      <Form.Item label="Course CPE" name="cpe">
                        <InputNumber
                          placeholder="Enter CPE credits"
                          style={{ width: "100%" }}
                          min={0}
                          parser={(value) => value.replace(/[^\d.]/g, "")}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row gutter={16}>
                    <Col span={9}>
                      <Form.Item label="Duration" required>
                        <Input.Group compact>
                          <Form.Item
                            name="duration"
                            noStyle
                            rules={[
                              {
                                required: true,
                                message: "Please enter duration",
                              },
                            ]}
                          >
                            <Input
                              style={{ width: "60%" }}
                              placeholder="Enter number"
                            />
                          </Form.Item>

                          <Form.Item
                            name="duration_type"
                            noStyle
                            initialValue="mins"
                            rules={[
                              {
                                required: true,
                                message: "Please select type",
                              },
                            ]}
                          >
                            <Select style={{ width: "40%" }}>
                              <Option value="mins">Mins</Option>
                              <Option value="hours">Hours</Option>
                            </Select>
                          </Form.Item>
                        </Input.Group>
                      </Form.Item>
                    </Col>
                    <Col span={4}>
                      <Form.Item label="Course Version" name="version">
                        <InputNumber
                          placeholder="Enter Version"
                          style={{ width: "100%" }}
                          min={0}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={3}>
                      <Form.Item
                        label="Year"
                        name="year"
                        rules={[
                          {
                            validator: (_, value) => {
                              if (!value)
                                return Promise.reject("Please enter a year");

                              const str = value.toString();
                              if (str.length !== 4)
                                return Promise.reject("Enter a 4-digit year");

                              if (value < 1980 || value > 2100)
                                return Promise.reject(
                                  "Year must be between 1980 and 2100"
                                );

                              return Promise.resolve();
                            },
                          },
                        ]}
                      >
                        <InputNumber
                          placeholder="YYYY"
                          style={{ width: "100%" }}
                          min={1980}
                          max={2100}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </>
              )}
              {courseType === "Onsite" && (
                <>
                  <Row gutter={16}>
                    <Col span={9}>
                      <Form.Item
                        label="No. Of Sessions"
                        required
                        rules={[
                          {
                            required: true,
                            message: "Sessions is required",
                          },
                        ]}
                        name="max_sessions"
                      >
                        <Input placeholder="Enter Number" />
                      </Form.Item>
                    </Col>
                  </Row>
                </>
              )}
              {!isCAAdmin && (
                <>
                  <Row gutter={16}>
                    <Col span={3}>
                      <Form.Item
                        label="Client Owned"
                        name="client_owned"
                        valuePropName="checked"
                        initialValue={false}
                      >
                        <Switch checkedChildren="Yes" unCheckedChildren="No" />
                      </Form.Item>
                    </Col>

                    <Form.Item
                      noStyle
                      shouldUpdate={(prev, curr) =>
                        prev.client_owned !== curr.client_owned
                      }
                    >
                      {({ getFieldValue }) => {
                        const showOwner = getFieldValue("client_owned");
                        return showOwner ? (
                          <Col span={8}>
                            <Form.Item
                              label="Client Owner"
                              name="owner"
                              rules={[
                                {
                                  required: true,
                                  message: "Please select an owner",
                                },
                              ]}
                            >
                              <Select
                                placeholder="Select Owner"
                                showSearch
                                optionFilterProp="children"
                                options={ownersList.map((owner) => ({
                                  label: owner.name,
                                  value: owner.id,
                                }))}
                              />
                            </Form.Item>
                          </Col>
                        ) : null;
                      }}
                    </Form.Item>
                  </Row>
                </>
              )}
              <Row gutter={16}>
                <Col span={24}>
                  <Form.Item label="Course Description" name="description">
                    <Input.TextArea rows={4} placeholder="Enter description" />
                  </Form.Item>
                </Col>
              </Row>

              <div
                className="group-1-box"
                style={{
                  paddingTop: "0rem",
                  paddingLeft: "0px",
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginLeft: "10px",
                  }}
                >
                  <span
                    style={{
                      marginRight: "10px",
                      fontWeight: 500,
                      fontSize: "14.75px",
                    }}
                  >
                    ILT Enabled :
                  </span>
                  <Form.Item
                    name="ilt_enabled"
                    initialValue={false}
                    valuePropName="checked"
                    style={{ marginBottom: 0 }}
                  >
                    <Switch size="medium" />
                  </Form.Item>
                </div>

                <div>
                  <div style={{ display: "inline-block" }}>
                    <Form.Item label=" " colon={false}>
                      <Button
                        type="text"
                        htmlType="button"
                        style={{
                          background: "#D3D3D3",
                        }}
                        onClick={() => {
                          history(
                            isCAAdmin
                              ? "/ca-admin/trainery-learn/courses/listing"
                              : "/trainery-learn/courses/listing"
                          );
                        }}
                      >
                        <BackwardOutlined />
                        Back
                      </Button>
                    </Form.Item>
                  </div>

                  <div style={{ display: "inline-block", marginLeft: "16px" }}>
                    <Form.Item label=" " colon={false}>
                      <Button
                        type="primary"
                        htmlType="submit"
                        className="save-update-btn"
                      // disabled
                      >
                        Save & Continue
                        <SaveOutlined />
                      </Button>
                    </Form.Item>
                  </div>
                  <div style={{ display: "inline-block", marginLeft: "16px" }}>
                    <Form.Item label=" " colon={false}>
                      <Button
                        type="text"
                        htmlType="button"
                        onClick={handleReset}
                        style={{
                          background: "#D3D3D3",
                        }}
                      >
                        Reset
                        <RetweetOutlined />
                      </Button>
                    </Form.Item>
                  </div>
                </div>
              </div>
            </Form>
          </Card>
        </div>
        <div style={{ flexBasis: "20%", height: "100%", marginRight: "15px" }}>
          <CourseAddRightBar
            formData={formValues}
            setUploadedFiles={setUploadedFiles}
            setTags={setTags}
            tags={tags}
          />
        </div>
      </div>
    </WrapperComponent>
  );
};

export default CourseAdd;
